module.exports = __webpack_public_path__ + "img/logo_bitcoin.00ba62e0.png";